import React, { memo } from "react";

import { useSnackbar } from "../../hooks/useSnackbar";
import { useShowDesktopLayout } from "../../hooks/useShowdesktopLayout";

import { Snackbar } from "./snackbar";

export const SnackbarContainer = memo(function SnackbarContainer() {
	const { snackbar, removeSnackbar } = useSnackbar();
	const isDesktopPosition = useShowDesktopLayout();

	function onRemove() {
		if (snackbar) {
			removeSnackbar(snackbar);
		}
	}

	if (!snackbar) return null;

	return (
		<Snackbar
			text={snackbar.text}
			closeTime={snackbar.closeTime}
			onRemove={onRemove}
			className={isDesktopPosition ? "snackbar--desktop" : undefined}
		/>
	);
});
